document.addEventListener('DOMContentLoaded', function () {

  const urlParams = new URLSearchParams(window.location.search);
  const designId = urlParams.get('clientDesignId');
  const isCartPage = window.location.pathname.includes('/cart');

  // --- ANTIGRO WORKFLOW (FOR RETURNS) ---
  if (designId) { handleAntigroReturn(designId); }

  // --- CART PAGE VALIDATION ---
  console.log(isCartPage, '----------isCartPage');
  if (isCartPage) {
    validateCartDesigns();
  }
  if (customerGlobalId) {
    syncGuestDesigns();
  }

});

// HELPER: The Image Warm-up Logic
function waitForImage(url, timeout = 5000) {
  return new Promise((resolve) => {
    const img = new Image();
    const timer = setTimeout(() => { resolve(); }, timeout);
    img.onload = () => { clearTimeout(timer); resolve(); };
    img.onerror = () => { setTimeout(resolve, 500); };
    img.src = url;
  });
}

async function handleAntigroReturn(id) {
  try {
    showFullLoader(locale === 'de' ? 'Wird in den Warenkorb gelegt...' : 'Verifying your design...');

    // 1. Get fresh data from Backend
    const response = await fetch(`${backendUrl}/antigro/callback?clientDesignId=${id}`);
    const verifiedData = await response.json();
    if (!verifiedData.success) throw new Error(verifiedData.error || 'Verification failed');

    // 2. Fetch current Shopify Cart
    const cartCheck = await fetch('/cart.js').then(res => res.json());

    // 3. Find the item in the cart by Design_ID
    const existingItem = cartCheck.items.find(item =>
      item.properties && (item.properties['Design_ID'] === id || item.properties['_Design_ID'] === id)
    );

    await waitForVariant(verifiedData.variant_id);

    if (existingItem) {
      // 4. CHECK IF PROPERTIES CHANGED
      const hasChanges = checkPropertyMismatches(existingItem, verifiedData);

      if (hasChanges) {
        console.log('Properties changed. Replacing item in cart...');
        // Remove old item first (by its unique key)
        // 1. Remove old item
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: existingItem.key, quantity: 0 })
        });

        // 2. Small delay (800ms) to allow Shopify to process the removal
        // and recognize the new variant status
        await new Promise(resolve => setTimeout(resolve, 3000));

        console.log('**********Returned Variant:', verifiedData.variant_id);

        // 3. Add the new version
        await addToShopifyCart(verifiedData);
        await waitForCartItem(verifiedData.variant_id);
      } else {
        console.log('No changes detected. Design ID already in cart with same specs.');
      }
    } else {
      console.log('**********Returned Variant else case:', verifiedData.variant_id);

      // 5. Not in cart at all, just add it
      await addToShopifyCart(verifiedData);
    }

    // Ensure preview is ready before redirecting
    if (verifiedData.preview) {
      await waitForImage(verifiedData.preview);
    }

    window.location.href = '/cart';

  } catch (error) {
    console.error('Antigro Return Error:', error);
    hideFullLoader();
    alert('Error: ' + error.message);
  }
}

/**
 * Compares Shopify line item properties with fresh Antigro data.
 * Returns true if any relevant property (Material, Finish, Qty) differs.
 */
function checkPropertyMismatches(shopifyItem, apiData) {

  const apiProps = apiData.properties || {};
  const cartProps = shopifyItem.properties || {};

  // 2. The Robust Check
  // Instead of relying on translated keys which might flip-flop,
  // let's define the specific technical fields we care about.
  const fieldsToVerify = [
    { label: 'Product', key: "Produkt" },
    { label: 'Width', key: "Breite" },
    { label: 'Height', key: "Höhe" },
    { label: 'Shape', key: "Form" },
    { label: 'Material', key: "Material" },
    { label: 'Finish', key: "Oberfläche / Finish" }
  ];

  for (let field of fieldsToVerify) {
    // Try to find the value in the API props using the translated key
    // If the API always sends German, use the German string here instead of field.key
    const newVal = String(apiProps[field.key] || '').trim();
    const oldVal = String(cartProps[field.key] || '').trim();
    console.log(`checking  in ${field.label} (${field.key}): API(${newVal}) vs Cart(${oldVal})`);
    if (newVal !== oldVal) {
      console.log(`Mismatch in ${field.label} (${field.key}): API(${newVal}) vs Cart(${oldVal})`);
      return true;
    }
  }

  return false;
}

/**
 * Strict Numeric Validation
 * Strips all non-digit characters and ensures a minimum of 1.
 */
window.changeLocalQty = function (inputId, delta = 0) {

  const input = document.getElementById(inputId);
  const warningDiv = document.getElementById(`Warning-${inputId.split('-')[1]}`);

  // 1. Strict Sanitization: Strip non-numeric characters
  let sanitizedValue = input.value.replace(/\D/g, '');
  let currentVal = parseInt(sanitizedValue) || 0;

  let newVal = currentVal + delta;

  // 2. Range Validation (1 - 100,000)
  const MIN_QTY = 1;
  const MAX_QTY = 100000;
  let errorKey = null;

  if (newVal > MAX_QTY) {
    newVal = MAX_QTY;
    errorKey = "Menge muss zwischen 1 und 100.000 liegen";
  } else if (newVal < MIN_QTY && sanitizedValue !== '') {
    newVal = MIN_QTY;
    errorKey = "Menge muss zwischen 1 und 100.000 liegen";
  }

  input.value = newVal;

  // 3. Handle Warning Visibility
  if (errorKey && warningDiv) {
    warningDiv.textContent = errorKey;
    warningDiv.classList.remove('hidden');
  } else if (warningDiv) {
    warningDiv.classList.add('hidden');
  }
};

// Add this to your input in Liquid to prevent typing letters/decimals
// <input oninput="changeLocalQty('Qty-')" ... >

/**
 * UI TRIGGER: Opens the modal for volume sync
 */
window.syncVolumeWithAntigro = function (itemKey, designId) {
  const input = document.getElementById(`Qty-${itemKey}`);
  const newVolume = parseInt(input.value);
  const oldVolume = parseInt(input.getAttribute('data-initial-qty'));

  // Don't even open the modal if nothing changed
  if (newVolume === oldVolume || isNaN(newVolume)) {
    return;
  }

  smModal.open({
    title: modalTranslations.volumeUpdateTitle,
    message: modalTranslations.volumeUpdateMsg,
    confirmText: modalTranslations.btnConfirmUpdate,
    type: 'primary', // Neon green button
    onConfirm: () => executeVolumeSync(itemKey, designId, newVolume)
  });
};

/** Wait until the old cart item is fully removed */
async function waitForCartItemRemoval(itemKey, attempts = 20) {

  for (let i = 0; i < attempts; i++) {

    try {

      const response = await fetch(
        `/cart.js?t=${Date.now()}`,
        {
          method: 'GET',
          cache: 'no-store',
          headers: {
            'Cache-Control': 'no-cache'
          }
        }
      );


      if (response.ok) {

        const cart = await response.json();

        const oldItemExists = cart.items?.some(
          item => item.key === itemKey
        );


        if (!oldItemExists) {

          console.log(
            `Old cart item ${itemKey} successfully removed`
          );

          return true;
        }
      }


    } catch (error) {

      console.warn(
        `Removal verification ${i + 1}/${attempts} failed`,
        error
      );
    }


    await sleep(500);
  }


  throw new Error(
    'Old cart item was not removed in time'
  );
}

/** Update Antigro volume and replace the Shopify cart item */
async function executeVolumeSync(
  itemKey,
  designId,
  newVolume
) {

  const warningDiv =
    document.getElementById(`Warning-${itemKey}`);


  showFullLoader(
    locale === 'de'
      ? 'Preis wird aktualisiert...'
      : 'Updating price...'
  );


  try {

    // 1. Ask backend/Antigro to update quantity and price
    const response = await fetch(
      `${backendUrl}/antigro/update-volume`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          designId,
          volume: newVolume
        })
      }
    );


    const result = await response.json();


    if (response.status === 422) {

      hideFullLoader();

      if (warningDiv) {

        warningDiv.textContent =
          result.message ||
          result.errors?.volume?.[0] ||
          'Invalid quantity';

        warningDiv.classList.remove('hidden');
      }

      return;
    }


    if (!response.ok || !result.success) {
      throw new Error(
        result.error || 'Update failed'
      );
    }


    console.log(
      'New variant returned:',
      result.variant_id
    );


    // 2. Confirm variant endpoint is available
    await waitForVariant(result.variant_id);


    const oldImage = document
      .querySelector(
        `[data-antigro-id="${designId}"]`
      )
      ?.closest('.cart-item')
      ?.querySelector('img')
      ?.src;


    // 3. Remove old cart line
    const removeResponse = await fetch(
      `/cart/change.js?t=${Date.now()}`,
      {
        method: 'POST',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      }
    );


    if (!removeResponse.ok) {
      throw new Error(
        'Failed to remove old cart item'
      );
    }


    // 4. Confirm Shopify cart has removed old line
    await waitForCartItemRemoval(itemKey);


    // 5. Add new dynamically priced variant
    await addToShopifyCart({
      variant_id: result.variant_id,
      design_id: designId,
      preview: result.preview || oldImage,
      properties: result.selected_properties
    });


    // 6. HoneyStickers-style confirmation:
    // wait until variant exists in cart with positive price
    await waitForCartItem(result.variant_id);


    // 7. Redirect only after Shopify cart state is confirmed
    window.location.replace(
      `/cart?t=${Date.now()}`
    );


  } catch (error) {

    hideFullLoader();

    console.error(
      'Volume sync error:',
      error
    );


    smModal.open({
      title: 'Error',
      message: error.message,
      confirmText: 'OK',
      type: 'danger'
    });
  }
}

/**
 * CART: Trigger removal using cart-specific wording
 */
window.removeAntigroItem = function (itemKey) {
  smModal.open({
    title: modalTranslations.cartDeleteTitle,      // "REMOVE FROM CART?"
    message: modalTranslations.cartDeleteMsg,      // "Do you want to remove this..."
    confirmText: modalTranslations.btnConfirmDelete,
    cancelText: modalTranslations.btnCancel,
    type: 'danger',
    onConfirm: () => executeCartRemoval(itemKey)
  });
};

/**
 * LOGIC: The actual fetch to Shopify AJAX API
 */
async function executeCartRemoval(itemKey) {
  showFullLoader(loadingMessages.remove);

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    });

    if (response.ok) {
      window.location.reload();
    } else {
      throw new Error("Cart API Error");
    }
  } catch (e) {
    console.error("Cart Removal Error:", e);
    hideFullLoader();

    smModal.open({
      title: "Error",
      message: "An error occurred while removing the item from your cart.",
      confirmText: "OK",
      type: 'danger'
    });
  }
}

// 2. NEW: HANDLE EDIT FROM CART
/**
 * UI TRIGGER: Opens the modal before redirecting to Antigro
 */
window.handleEditDesign = function (id) {
  smModal.open({
    title: modalTranslations.editTitle,
    message: modalTranslations.editMsg,
    confirmText: modalTranslations.btnConfirmEdit,
    type: 'primary', // Matches the "Update" and "Reorder" neon style
    onConfirm: () => executeEditDesign(id)
  });
};

/**
 * LOGIC EXECUTION: Handles the unlock request and redirect
 */
async function executeEditDesign(id) {

  try {
    showFullLoader(locale === 'de' ? 'Design wird zum Bearbeiten geöffnet...' : 'Opening design for editing...');

    // 1. Request the unlock and the URL from backend
    const response = await fetch(`${backendUrl}/antigro/reopen`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        clientDesignId: id,
        locale: locale
      })
    });

    const result = await response.json();

    if (result.success && result.designer_url) {
      // 2. Redirect directly into the Antigro Designer
      window.location.href = result.designer_url;
    } else {
      throw new Error(result.error || 'Could not unlock design');
    }
  } catch (error) {
    hideFullLoader();
    console.error('Edit Error:', error);

    // Show stylish error modal instead of standard alert
    smModal.open({
      title: "Error",
      message: error.message,
      confirmText: "OK",
      type: 'danger'
    });
  }
}

// 3. NEW: CART VALIDATION (Check if designs are ACCEPTED)
async function validateCartDesigns() {

  const designElements = document.querySelectorAll('[data-antigro-id]');

  // 1. Map and Filter out empty values immediately
  const ids = Array.from(designElements)
    .map(el => el.dataset.antigroId)
    .filter(id => id && id.trim() !== ''); // Removes "", null, or " "

  if (ids.length === 0) return;

  try {
    const response = await fetch(`${backendUrl}/antigro/validate-cart`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ designIds: ids })
    });

    const result = await response.json();

    // We expect the backend to return:
    // { success: true, statusMap: {...}, invalidIds: [...] }
    const statusMap = result.statusMap || result;
    const invalidIds = result.invalidIds || [];

    let hasUnacceptedDesign = false;
    let itemsRemoved = false;

    console.log(invalidIds, '----------invalidIds');
    // 1. HANDLE DELETIONS (Ghost Designs)
    if (invalidIds.length > 0) {
      for (const id of invalidIds) {
        const container = document.querySelector(`[data-antigro-id="${id}"]`);

        if (container) {
          // We need the Shopify Item Key to remove it from the cart
          const itemKey = container.dataset.itemKey;

          if (itemKey) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: itemKey, quantity: 0 })
            });
            itemsRemoved = true;
          }
        }
      }
    }

    // 2. HANDLE UPDATES (Thumbnails & Warnings)
    ids.forEach(id => {
      // Skip if this ID was just flagged for removal
      if (invalidIds.includes(id)) return;

      const data = statusMap[id];
      if (!data) return;

      const container = document.querySelector(`[data-antigro-id="${id}"]`);

      // Dynamically load image
      const imageBlock = document.getElementById(`image_${id}`);
      if (imageBlock && data.preview) {
        imageBlock.src = data.preview;
      }

      // --- STATUS CHECK (NEW / NOT ACCEPTED) ---
      // Normalize to uppercase just in case
      const currentStatus = (data.status || '').toUpperCase();

      if (currentStatus === 'NEW') {
        hasUnacceptedDesign = true;

        if (container && !container.querySelector('.status-warning')) {
          const infoText = locale === 'de'
            ? 'Um dein Design zu bestätigen, klicke auf „Personalisierung ändern“, gib das Stickerdesign im Editor erneut frei und lege es in den Warenkorb.'
            : 'To confirm your design, click “Change personalization”, approve the sticker design again in the editor and add it to the cart.';

          const warningHtml = `
              <div class="status-warning">
                <span class="status-warning-label">
                  ${locale === 'de' ? 'Nicht akzeptiert' : 'Not accepted'}
                </span>

                <span class="status-info" tabindex="0">
                  <span class="status-info-icon">i</span>
                  <span class="status-info-tooltip">
                    ${infoText}
                  </span>
                </span>
              </div>
            `;

          container.insertAdjacentHTML('beforeend', warningHtml);
        }
      }
    });

    // 3. UI FEEDBACK
    if (itemsRemoved) {
      smModal.open({
        title: modalTranslations.cartDeleteTitle || "HINWEIS",
        message: "Einige Designs sind nicht mehr verfügbar und wurden aus deinem Warenkorb entfernt.",
        confirmText: "OK",
        type: 'primary',
        onConfirm: () => window.location.reload()
      });
    } else if (hasUnacceptedDesign) {
      disableCheckoutWithMsg();
    }

  } catch (e) {
    console.error('Validation error', e);
  }
}

function disableCheckoutWithMsg() {

  const checkoutBtns = document.querySelectorAll('[name="checkout"], .checkout-button');
  const msg = locale === 'de'
    ? 'Bitte akzeptieren Sie alle Designs, um fortzufahren.'
    : 'Please accept all designs to proceed to checkout.';

  checkoutBtns.forEach(btn => {
    btn.disabled = true;
    btn.style.opacity = '0.5';
    btn.style.cursor = 'not-allowed';

    // Add a small message above the checkout button if it doesn't exist
    if (!document.getElementById('checkout-warning-msg')) {
      btn.insertAdjacentHTML('beforebegin', `
          <p id="checkout-warning-msg" style="color: #d72c0d; font-weight: bold; font-size: 13px; margin-bottom: 10px; text-align: center;">
            ⚠️ ${msg}
          </p>
        `);
    }
  });
}

let currentStep = 0;

// Helper: Move Slider
function moveCPSlider(direction) {
  const slider = document.getElementById('CP-Slider');
  const totalImages = slider.children.length;
  if (totalImages === 0) return;
  currentStep = (currentStep + direction + totalImages) % totalImages;
  updateSliderPosition();
}

// Helper: Update Position
function updateSliderPosition() {
  const slider = document.getElementById('CP-Slider');
  if (slider) {
    slider.style.transform = `translateX(-${currentStep * 100}%)`;
  }
}

// Helper: Close Modal
function closePreviewModal() {
  const modal = document.getElementById('CheckoutPreviewModal');
  if (modal) modal.classList.remove('active');
}

/**
 * Event Delegation: One listener for all cart actions
 */
// document.addEventListener('click', function(e) {
//   const modal = document.getElementById('CheckoutPreviewModal');
//   const cartForm = document.querySelector('form[action="/cart"]');

//   // --- 1. HANDLE THE PROCEED BUTTON (Inside Modal) ---
//   if (e.target.id === 'CP-Proceed' && customerGlobalId == 23692228886872) {
//     if (cartForm) {
//       // We append a hidden input to ensure Shopify knows this is a Checkout action
//       const checkoutInput = document.createElement('input');
//       checkoutInput.type = 'hidden';
//       checkoutInput.name = 'checkout';
//       checkoutInput.value = 'Checkout';
//       cartForm.appendChild(checkoutInput);

//       cartForm.submit();
//     }
//     return;
//   }

//   // --- 2. HANDLE CLOSE/CANCEL ACTIONS ---
//   if (
//     e.target.id === 'CP-Close-X' ||
//     e.target.id === 'CP-Cancel' ||
//     e.target.id === 'CheckoutPreviewModal'
//   ) {
//     closePreviewModal();
//     return;
//   }

//   // --- 3. HANDLE THE MAIN CHECKOUT BUTTON (Open Modal) ---
//   const checkoutBtn = e.target.closest('button[name="checkout"]');
//   if (checkoutBtn) {
//     const designImages = document.querySelectorAll('img[id^="image_"]');
//     const slider = document.getElementById('CP-Slider');

//     // Only intercept if there are designs to show
//     if (modal && slider && designImages.length > 0) {
//       e.preventDefault(); // Stop immediate checkout

//       slider.innerHTML = '';
//       designImages.forEach(img => {
//         const newImg = document.createElement('img');
//         newImg.src = img.src;
//         slider.appendChild(newImg);
//       });

//       currentStep = 0;
//       updateSliderPosition();
//       modal.classList.add('active');
//     }
//   }
// });